import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../../Navbar/Navbar";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Typography, TextField, Box, Pagination
} from "@mui/material";
import baseURL from "../../config"; // Ensure baseURL is set
import { useNavigate } from "react-router-dom";

const AllAdminContract = () => {
    const [contracts, setContracts] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const contractsPerPage = 10; // Number of items per page

    const navigate = useNavigate();

    useEffect(() => {
        fetchContractDetails();
    }, []); // Fetch only once, as we handle pagination on frontend

    const fetchContractDetails = async () => {
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(`${baseURL}/api/getContractDetails`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                  },
            });
            setContracts(response.data.contracts || []);
        } catch (error) {
            console.error("Error fetching contract details:", error);
        }
    };

    // Filter contracts based on search input
    const filteredContracts = contracts.filter(contract =>
        search.trim() === "" || contract?.vesselName?.toLowerCase()?.includes(search.toLowerCase())
    );

    // Calculate total pages based on filtered results
    const totalPages = Math.ceil(filteredContracts.length / contractsPerPage);

    // Get paginated data
    const paginatedContracts = filteredContracts.slice(
        (currentPage - 1) * contractsPerPage,
        currentPage * contractsPerPage
    );

    return (
        <>
            <Navbar />
            <Box sx={{ p: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                    <TextField
                        label="Search by Vessel Name..."
                        variant="outlined"
                        size="small"
                        sx={{ width: "250px" }}
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1); // Reset to page 1 on new search
                        }}
                    />
                    <Typography variant="h5" fontWeight="bold" sx={{ flexGrow: 1, textAlign: "center" }}>
                        📋 All Contracts
                    </Typography>
                </Box>

                <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#1976D2", color: "white" }}>
                                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sr. No.</TableCell>
                                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Vessel Owner</TableCell>
                                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Crew</TableCell>
                                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Crewing Agent</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedContracts.length > 0 ? (
                                paginatedContracts.map((contract, index) => (
                                    <TableRow key={contract._id}>
                                        <TableCell>{(currentPage - 1) * contractsPerPage + index + 1}</TableCell>
                                        <TableCell>
                                            <Typography fontWeight="bold">
                                                Contract Created At: {new Date(contract.createdAt).toLocaleString()}
                                            </Typography>
                                            <Typography>Company: {contract.vesselOwner?.company_shortname || "N/A"}</Typography>
                                            <Typography>Vessel: {contract.ShipDetails?.vesselname}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography fontWeight="bold">Name: {contract?.crewdetails?.name}</Typography>
                                            <Typography>Indos No.: {contract?.crewdetails?.indosno || "N/A"}</Typography>
                                            <Typography>Email: {contract?.crewdetails?.email}</Typography>
                                            <Typography>Rank: {contract?.crewdetails?.rankname}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{contract?.crewingAgent?.agentName}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        No Contracts Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Pagination Component */}
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        color="primary"
                    />
                </Box>
            </Box>
        </>
    );
};

export default AllAdminContract;
